import { Box } from '@branch-messenger/willow-ui'
import styled, { css } from 'styled-components'

import { tabletAndDown } from '@/styles/media'

export const CreateDebitCardContainer = styled(Box).attrs({ $fullWidth: true })`
  height: 650px;
  & iframe {
    height: 100%;
    width: 100%;
    border: none;
  }
  ${tabletAndDown(css`
    height: 700px;
  `)}
`
